const apps = [{
        appType: 'QHD',
        icon: 'https://easystock.oss-cn-hangzhou.aliyuncs.com/d95d4928086b48d0908c7a5eff7b19f1.png',
        name: '趣互动',
        desc: '通过游戏化的产品设计、智能推荐技术的运用，实现高效的导购管理和导购赋能，帮助企业激活导购力量。',
        // link: 'https://vorwerk-image.oss-cn-shanghai.aliyuncs.com/e465973f17e444aabfdb6182fc447865.mp4',
        link: '',
        miniCode: 'https://easystock.oss-cn-hangzhou.aliyuncs.com/a5cdb93ca3bd44e4b4ed9c259d210317.png',
        // miniCode: 'https://easystock.oss-cn-hangzhou.aliyuncs.com/a64471134f544bdc8a3d411ee6933031.png',
        stat: 1,
    },
    {
        appType: 'BEAUTY',
        icon: 'https://easystock.oss-cn-hangzhou.aliyuncs.com/7b0160da4676410c8edf3b4b3a6648df.png',
        name: '医美会员',
        desc: '帮助医美机构搭建私域流量池，提供储值、拼团、秒杀等会员活动，实现医美私域数字化增长。',
        link: '',
        miniCode: 'https://easystock.oss-cn-hangzhou.aliyuncs.com/55c0c7439672460f931efbf94cbfa97f.png',
        miniText: '即将上线，敬请期待',
        stat: 0,
    },
    {
        appType: 'QDG',
        icon: 'https://easystock.oss-cn-hangzhou.aliyuncs.com/447ac8e8041243fba16c82db9e9354f1.png',
        name: '趣导购',
        desc: '通过游戏化的产品设计和精准的数学模型，帮助企业快速拉新、增加留存和提高GMV。',
        link: '',
        miniCode: 'https://easystock.oss-cn-hangzhou.aliyuncs.com/55c0c7439672460f931efbf94cbfa97f.png',
        miniText: '即将上线，敬请期待',
        stat: 0,
    },
    {
        appType: 'YGT',
        icon: 'https://easystock.oss-cn-hangzhou.aliyuncs.com/13a34c148c204438a158f6e6c224c4b8.png',
        name: '云柜台',
        desc: '通过游戏化的产品设计、智能推荐技术的运用，实现高效的导购管理和导购赋能，帮助企业激活导购力量。',
        link: '',
        miniCode: 'https://easystock.oss-cn-hangzhou.aliyuncs.com/55c0c7439672460f931efbf94cbfa97f.png',
        miniText: '即将上线，敬请期待',
        stat: 0,
    }
]

const appStatus = {
    1: '试用中',
    2: '已开通',
    3: '已过期'
}

const statusObj = {
    '试用中': 1,
    '已开通': 2,
    '已过期': 3
}

const statusBg = {
    1: '#A861FE',
    2: '#FEB800',
    3: '#2F3169'
}

const appPath = {
    'QHD': 'qhd/qhd-home',
    'BEAUTY': 'beauty',
    'QDG': 'qdg',
    'YGT': 'ygt'
}

const appName = {
    'QHD': '趣互动',
    'BEAUTY': '医美会员',
    'QDG': '趣导购',
    'YGT': '云柜台'
}

export {
    apps,
    appStatus,
    statusBg,
    appPath,
    statusObj,
    appName
}